import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import validSupergitHIS from "../../api/validSupergitHIS";
import toast from "react-hot-toast";

export const getLeavesList = createAsyncThunk(
  "getLeavesList",
  async (data, { rejectWithValue, getState }) => {
    try {
      const response = await validSupergitHIS.post("leaves/list", data);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.error || "something went wrong");
      if (error.response && error.response.status === 401) {
        const state = getState();
        state.auth.token = null;
        state.auth.user = null;
      }
      return rejectWithValue(
        error?.response?.data?.error || "something went wrong"
      );
    }
  }
);

export const CreateNewLeave = createAsyncThunk(
  "CreateNewLeave",
  async (data, { rejectWithValue }) => {
    try {
      const response = await validSupergitHIS.post("leaves", data);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.error || "something went wrong");
      return rejectWithValue(
        error?.response?.data?.error || "something went wrong"
      );
    }
  }
);


export const CreateNewAttendance = createAsyncThunk(
  "CreateNewAttendance",
  async (data, { rejectWithValue }) => {
    try {
      const response = await validSupergitHIS.post("attendances", data);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.error || "something went wrong");
      return rejectWithValue(
        error?.response?.data?.error || "something went wrong"
      );
    }
  }
);

export const getAttendanceList = createAsyncThunk(
  "getAttendanceList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await validSupergitHIS.post("attendances/list", data);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.error || "something went wrong");
      return rejectWithValue(
        error?.response?.data?.error || "something went wrong"
      );
    }
  }
);


export const CreateNewDeduction = createAsyncThunk(
  "CreateNewDeduction",
  async (data, { rejectWithValue }) => {
    try {
      const response = await validSupergitHIS.post("deductions", data);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.error || "something went wrong");
      return rejectWithValue(
        error?.response?.data?.error || "something went wrong"
      );
    }
  }
);

export const getDeductionList = createAsyncThunk(
  "getDeductionList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await validSupergitHIS.post("deductions/list", data);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.error || "something went wrong");
      return rejectWithValue(
        error?.response?.data?.error || "something went wrong"
      );
    }
  }
);


export const CreateNewAllowance = createAsyncThunk(
  "CreateNewAllowance",
  async (data, { rejectWithValue }) => {
    try {
      const response = await validSupergitHIS.post("allowances", data);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.error || "something went wrong");
      return rejectWithValue(
        error?.response?.data?.error || "something went wrong"
      );
    }
  }
);

export const getAllowanceList = createAsyncThunk(
  "getAllowanceList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await validSupergitHIS.post("allowances/list", data);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.error || "something went wrong");
      return rejectWithValue(
        error?.response?.data?.error || "something went wrong"
      );
    }
  }
);

export const deleteLeave = createAsyncThunk(
  "deleteLeave",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await validSupergitHIS.delete(`leaves/${id}`);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.error || "something went wrong");
      return rejectWithValue(
        error?.response?.data?.error || "something went wrong"
      );
    }
  }
);

export const deleteAttendance = createAsyncThunk(
  "deleteAttendance",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await validSupergitHIS.delete(`attendances/${id}`);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.error || "something went wrong");
      return rejectWithValue(
        error?.response?.data?.error || "something went wrong"
      );
    }
  }
);

export const deleteDeduction = createAsyncThunk(
  "deleteDeduction",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await validSupergitHIS.delete(`deductions/${id}`);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.error || "something went wrong");
      return rejectWithValue(
        error?.response?.data?.error || "something went wrong"
      );
    }
  }
);

export const deleteAllowance = createAsyncThunk(
  "deleteAllowance",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await validSupergitHIS.delete(`allowances/${id}`);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.error || "something went wrong");
      return rejectWithValue(
        error?.response?.data?.error || "something went wrong"
      );
    }
  }
);

export const UpdateLeave = createAsyncThunk(
  "UpdateLeave",
  async (data, { rejectWithValue }) => {
    try {
      const response = await validSupergitHIS.post("leaves/update", data);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.error || "something went wrong");
      return rejectWithValue(
        error?.response?.data?.error || "something went wrong"
      );
    }
  }
);

export const UpdateAttendance = createAsyncThunk(
  "UpdateAttendance",
  async (data, { rejectWithValue }) => {
    try {
      const response = await validSupergitHIS.post("attendances/update", data);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.error || "something went wrong");
      return rejectWithValue(
        error?.response?.data?.error || "something went wrong"
      );
    }
  }
);

export const UpdateDeduction = createAsyncThunk(
  "UpdateDeduction",
  async (data, { rejectWithValue }) => {
    try {
      const response = await validSupergitHIS.post("deductions/update", data);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.error || "something went wrong");
      return rejectWithValue(
        error?.response?.data?.error || "something went wrong"
      );
    }
  }
);

export const UpdateAllowance = createAsyncThunk(
  "UpdateAllowance",
  async (data, { rejectWithValue }) => {
    try {
      const response = await validSupergitHIS.post("allowances/update", data);
      return response.data;
    } catch (error) {
      toast.error(error?.response?.data?.error || "something went wrong");
      return rejectWithValue(
        error?.response?.data?.error || "something went wrong"
      );
    }
  }
);


const initialState = {
  isLoading: false,
  leavesList: [],
  attendanceList: [],
  deductionList: [],
  allowanceList: [],
};

const HrSlice = createSlice({
  name: "hr",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(CreateNewLeave.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(CreateNewLeave.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(CreateNewLeave.rejected, (state) => {
        state.isLoading = false;
      })

      .addCase(CreateNewAttendance.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(CreateNewAttendance.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(CreateNewAttendance.rejected, (state) => {
        state.isLoading = false;
      })

      .addCase(CreateNewDeduction.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(CreateNewDeduction.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(CreateNewDeduction.rejected, (state) => {
        state.isLoading = false;
      })

      .addCase(CreateNewAllowance.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(CreateNewAllowance.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(CreateNewAllowance.rejected, (state) => {
        state.isLoading = false;
      })


      .addCase(getLeavesList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getLeavesList.fulfilled, (state, action) => {
        state.leavesList = action.payload;
        state.isLoading = false;
      })
      .addCase(getLeavesList.rejected, (state) => {
        state.isLoading = false;
      })

      .addCase(getAttendanceList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAttendanceList.fulfilled, (state, action) => {
        state.attendanceList = action.payload;
        state.isLoading = false;
      })
      .addCase(getAttendanceList.rejected, (state) => {
        state.isLoading = false;
      })

      .addCase(getDeductionList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getDeductionList.fulfilled, (state, action) => {
        state.deductionList = action.payload;
        state.isLoading = false;
      })
      .addCase(getDeductionList.rejected, (state) => {
        state.isLoading = false;
      })

      .addCase(getAllowanceList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllowanceList.fulfilled, (state, action) => {
        state.allowanceList = action.payload;
        state.isLoading = false;
      })
      .addCase(getAllowanceList.rejected, (state) => {
        state.isLoading = false;
      })

      .addCase(deleteLeave.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteLeave.fulfilled, (state, action) => {
        state.isLoading = false;
        toast.success(action.payload.message || "Leave deleted successfully");
      })
      .addCase(deleteLeave.rejected, (state) => {
        state.isLoading = false;
      })

      .addCase(deleteAttendance.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteAttendance.fulfilled, (state, action) => {
        state.isLoading = false;
        toast.success(action.payload.message || "Attendance deleted successfully");
      })
      .addCase(deleteAttendance.rejected, (state) => {
        state.isLoading = false;
      })

      .addCase(deleteDeduction.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteDeduction.fulfilled, (state, action) => {
        state.isLoading = false;
        toast.success(action.payload.message || "Deduction deleted successfully");
      })
      .addCase(deleteDeduction.rejected, (state) => {
        state.isLoading = false;
      })

      .addCase(deleteAllowance.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteAllowance.fulfilled, (state, action) => {
        state.isLoading = false;
        toast.success(action.payload.message || "Allowance deleted successfully");
      })
      .addCase(deleteAllowance.rejected, (state) => {
        state.isLoading = false;
      })

      .addCase(UpdateLeave.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(UpdateLeave.fulfilled, (state, action) => {
        state.isLoading = false;
        toast.success(action.payload.message || "Leave updated successfully");
      })
      .addCase(UpdateLeave.rejected, (state) => {
        state.isLoading = false;
      })

      .addCase(UpdateAttendance.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(UpdateAttendance.fulfilled, (state, action) => {
        state.isLoading = false;
        toast.success(action.payload.message || "Attendance updated successfully");
      })
      .addCase(UpdateAttendance.rejected, (state) => {
        state.isLoading = false;
      })

      .addCase(UpdateDeduction.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(UpdateDeduction.fulfilled, (state, action) => {
        state.isLoading = false;
        toast.success(action.payload.message || "Deduction updated successfully");
      })
      .addCase(UpdateDeduction.rejected, (state) => {
        state.isLoading = false;
      })

      .addCase(UpdateAllowance.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(UpdateAllowance.fulfilled, (state, action) => {
        state.isLoading = false;
        toast.success(action.payload.message || "Allowance updated successfully");
      })
      .addCase(UpdateAllowance.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export default HrSlice.reducer;
